module.exports = __webpack_public_path__ + "static/media/1 封面.64ea9526.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/德文郡奶油/1 封面.JPG
// module id = 235
// module chunks = 0